import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import { Fragment } from 'react'

const FilterDisabledLayer = ({ filterRef }) => {
  const { left, bottom } = filterRef?.current?.getBoundingClientRect() || {
    left: 0,
    bottom: 0,
  }
  const container = document.getElementById('kakaoContent')
  const { top: containerTop, left: containerLeft } = container
    ? container.getBoundingClientRect()
    : {
        top: 0,
        left: 0,
      }
  return container ? (
    createPortal(
      <div
        className="tooltip_basic show place-bottom ly_tooltip2"
        style={{
          position: 'absolute',
          top: bottom - containerTop,
          left: left - containerLeft,
          margin: 0,
        }}>
        <p className="txt_tooltip4">개별변경시 필터를 수정할 수 없습니다</p>
      </div>,
      container
    )
  ) : (
    <Fragment />
  )
}
FilterDisabledLayer.propTypes = {
  filterRef: PropTypes.object,
}
export default FilterDisabledLayer
